module.exports = __webpack_public_path__ + "assets/images/pages/ebaysocial/ebaysocial-2.webp?804fcc9c";